module.exports = __webpack_public_path__ + "img/Weapon_129.23dd9d8f.png";